import { Body, Modal, Text, Title } from '@icarros/ids-react';
import { ModalInfoChassiContent, ModalInfoChassiLayout } from './style';

import { ReactComponent as DocumentoChassi } from './../.././../../../src/assets/rebranding/illustrations/documento-chassi.svg';
import React from 'react';
import { useAdContext } from '../../../store/contexts/ad';

interface ModalInfoChassiProps {
  modalOpen: boolean;
  setModalOpen(value: boolean): void;
}

export function ModalInfoChassi({
  setModalOpen
}: Readonly<ModalInfoChassiProps>): JSX.Element {
  const { modalInfoChassi, setModalInfoChassi } = useAdContext();

  return (
    <Modal
      stateOpen={[
        modalInfoChassi,
        () => {
          setModalOpen(false);
        }
      ]}
      body={
        <Body size="body_2" contrast="default" weight="regular" variant="base">
          <ModalInfoChassiLayout>
            <DocumentoChassi />
            <ModalInfoChassiContent>
              <Text>Você encontra na parte da frente do seu CRV ou CRLV.</Text>

              <Text>CRV é o documento de propriedade do veículo.</Text>
              <Text>Já o CRLV é o Certificado de Registro e Licenciamento do Veículo.</Text>

              <Text>Por que é importante informar corretamente a placa e o chassi?</Text>
              <Text>O chassi, combinado com a placa, confirma que seu veículo existe.</Text>
            </ModalInfoChassiContent>
          </ModalInfoChassiLayout>
        </Body>
      }
      titleElement={<Title>Onde encontro o número do chassi?</Title>}
      mainButtonMethod={() => setModalInfoChassi(false)}
      buttonType='pilled'
      mainButtonText='Entendi'
    />
  );
}
